import { register } from '|>/shared/vjs'
import { BaseTextTrackSettings } from '../../base'

/**
 * Modal dialog for manipulating text tracks (subtitles) settings
 * TODO: implement and style
 */
@register
export class TextTrackSettings extends BaseTextTrackSettings {}
